/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable camelcase */
import { Button, Typography } from "@mui/material";
import VehicleDashboardTable from "./VehicleDashboardTable";
import { useContext, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Vocabulary } from "../Utils/Vocabulary";
import { urlEnum } from "../Utils/urlEnum";
import { VehicleDashboardTableType } from "../Utils/autocompleteEnum";
import { VehicleContext } from "../Context/vehicleContext";
import {
  europeanDate,
  formatNumber,
  usDateFormatWithTime,
} from "../Utils/formatDate";
import moment from "moment";

export default function VehicleDocuments() {
  const vehicleContext: any = useContext(VehicleContext);
  const [openModal, setOpenModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [selected, setSelected]: any = useState(null);

  const columns = [
    {
      name: "id",
      label: "ID",
      options: {
        filter: false,
        sort: true,
        display: false,
      },
    },
    {
      name: "name",
      label: "Nume fisier",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (numeFisier: number) => (
          <div style={{ maxWidth: 350 }}>
            <Typography style={{ wordBreak: "break-all" }}>
              {numeFisier}
            </Typography>
          </div>
        ),
      },
    },
    {
      name: "tip_fisier",
      label: "Tip document",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "tip_financiar",
      label: "Tip financiar",
      options: {
        display: false,
        filter: true,
        sort: false,
      },
    },
    {
      name: "descriere_financiar",
      label: "Descriere",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (descriere: number) => (
          <div style={{ maxWidth: 350 }}>
            <Typography style={{ wordBreak: "break-all" }}>
              {descriere}
            </Typography>
          </div>
        ),
      },
    },
    {
      name: "suma_financiar",
      label: "Suma",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (suma_financiar: any) => (
          <Typography>
            {suma_financiar && suma_financiar !== "null"
              ? formatNumber(suma_financiar)
              : 0}{" "}
          </Typography>
        ),
      },
    },
    {
      name: "status_financiar",
      label: "Status",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "date",
      label: "Data",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (date: any) => (
          <>
            {date
              ? moment(date, usDateFormatWithTime).format(europeanDate)
              : ""}
          </>
        ),
      },
    },
    {
      name: "id",
      label: " ",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "tip_fisier",
      label: " ",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "file",
      label: " ",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "file",
      label: " ",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (url: string) => {
          let path = `${urlEnum.vehicles}/${url}`;
          if (url.includes("templates")) {
            const fileName = url.split("/").pop();
            path = `${urlEnum.templates}/getDoc/${fileName}`;
          }
          return (
            <Button
              style={{ float: "right" }}
              size="small"
              color="primary"
              variant="contained"
              data-file={path}
            >
              {Vocabulary.open}
            </Button>
          );
        },
      },
    },
    {
      name: "",
      label: "",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (rowIndex: number) => (
          <div style={{ float: "right", display: "flex" }}>
            <EditIcon
              style={{
                marginRight: 15,
                height: 30,
                cursor: "pointer",
                color: "#4449",
              }}
              onClick={(event: any) => {
                event.stopPropagation();
                setSelected(vehicleContext?.state?.documents[rowIndex]);
                setOpenEditModal(true);
              }}
            ></EditIcon>
            <DeleteIcon
              style={{ height: 30, cursor: "pointer", color: "#4449" }}
              onClick={(event: any) => {
                event.stopPropagation();
                setSelected(vehicleContext?.state?.documents[rowIndex]);
                setOpenModal(true);
              }}
            ></DeleteIcon>
          </div>
        ),
      },
    },
  ];

  const emptyFields = () => {
    setSelected(null);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div style={{ display: "flex" }}>
        <div
          style={{
            width: "100%",
            margin: 10,
            overflowY: "auto",
          }}
        >
          <VehicleDashboardTable
            // key={selected?.id}
            title={Vocabulary.documente}
            data={vehicleContext?.state?.documents}
            columns={columns}
            type={VehicleDashboardTableType.files}
            editData={selected}
            openEditModal={openEditModal}
            closeModal={() => {
              setOpenEditModal(false);
              setSelected(null);
            }}
            emptyFields={emptyFields}
            openModalDelete={openModal}
            closeModalDelete={() => {
              setSelected(null);
              setOpenModal(false);
            }}
          />
        </div>
      </div>
    </div>
  );
}
